import qyglGetter from '../getters/qyglGetter'
import qyglAction from '../actions/qyglAction'
import qyglMutation from '../mutations/qyglMutation'

const qyglModule = {
    state: {
        learnAddEmployees: {},
        learnWeixinPayCode: {},
        learnWeixinPayResult: {},
        enterpriseEmployee: {},
        enterpriseApprove: {},
        learningmgtQY: {},
        makeUpLearnDetails: {},
        enterpriseMakeUpApprove: {},
        enterprise: {},
        cmType: [],
        cmJob: [],
        cmCertificate: {},
        cmCertificateDetails: {},
        remoteCmCertificate: [],
        cmEmployee: {},
        cmEmployeeDetails: {},
        cmProject: {},
        cmProjectDetails: {},
        approveLearns: {},
        invoiceApproves: {},
        lastInvoiceApprove: {},
        invoiceApproveStates: [],
        invoiceApproveContractTemplate: {},
        bdyTestBatchEmployees: {},
        bdyTestBatchAddEmployees: {},
        selectBdyTestSessions: [],

        examBatchEmployees: {},
        examBatchAddEmployees: {},
        selectExamSessions: [],

        enterpriseModifyApproves: {},
        enterpriseModifyApproveStates: [],

        bdyPracticeEnrollAddEmployees: [],

        zjyTestBatchAddEmployees: {},

        certOldSources: [],
        certOldSource: {},
        enterpriseCertReplaces: {},
        certReplaceDetails: {},
        certReplaceApproveStates: [],

        sqEmployeeChangeApproves: {},
        shEmployeeChangeApproves: {},
        shEmployeeChangeApproveCount: 0,
        employeeChangeApproveStates: [],
        searchChangeEmployee: {}
    },
    getters: qyglGetter,
    actions: qyglAction,
    mutations: qyglMutation
}

export default qyglModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/qyglModule.js